import React, { forwardRef } from 'react';
import { Button } from '#components/button/button.tsx';
import { styled } from '../../theme';
import { useThemeStrings } from '../../hooks/use-theme';

export const ScrollableWrapper = styled('div', {
  position: 'relative',
  maxWidth: '100%',
});

export const ScrollableItemsWrapper = styled('div');

export const ButtonWrapper = styled('div', {
  backgroundColor: '$surfaceBackgroundPrimary',
  position: 'absolute',
  top: 0,
  bottom: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export interface GDSScrollButtonProps {
  onClick?: (event: React.SyntheticEvent) => void;
}

export const ScrollBack = forwardRef<HTMLButtonElement, GDSScrollButtonProps>(
  ({ onClick }, ref) => {
    const strings = useThemeStrings();
    return (
      <ButtonWrapper css={{ insetInlineStart: 0 }}>
        <Button
          className="GDS-scroll-button GDS-scroll-back-button GDS-scroll-left-button"
          size="small"
          icon="interfaceChevronBack"
          priority="tertiary"
          hideLabel
          onClick={onClick}
          ref={ref}
        >
          {strings.previous}
        </Button>
      </ButtonWrapper>
    );
  },
);

export const ScrollForward = forwardRef<
  HTMLButtonElement,
  GDSScrollButtonProps
>(({ onClick }, ref) => {
  const strings = useThemeStrings();
  return (
    <ButtonWrapper css={{ insetInlineEnd: 0 }}>
      <Button
        className="GDS-scroll-button GDS-scroll-forward-button GDS-scroll-right-button"
        size="small"
        icon="interfaceChevronForward"
        priority="tertiary"
        hideLabel
        onClick={onClick}
        ref={ref}
      >
        {strings.next}
      </Button>
    </ButtonWrapper>
  );
});
